import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import Icon from './Icon';

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-2">
                <Icon name="gavel" className="text-primary-600" />
                <span className="text-xl font-bold text-primary-600">Auction Platform</span>
              </Link>
              <div className="hidden md:flex ml-10 space-x-8">
                <Link
                  to="/"
                  className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium flex items-center gap-1"
                >
                  <Icon name="store" size="small" />
                  Auctions
                </Link>
                {isAuthenticated && (
                  <>
                    <Link
                      to="/create"
                      className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium flex items-center gap-1"
                    >
                      <Icon name="add_circle" size="small" />
                      Create Auction
                    </Link>
                    <Link
                      to="/wallet"
                      className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium flex items-center gap-1"
                    >
                      <Icon name="account_balance_wallet" size="small" />
                      Wallet
                    </Link>
                  </>
                )}
                <Link
                  to="/demo"
                  className="text-orange-600 hover:text-orange-700 px-3 py-2 text-sm font-medium flex items-center gap-1"
                >
                  <Icon name="smart_toy" size="small" />
                  Demo Panel
                </Link>
                <Link
                  to="/how-it-works"
                  className="text-blue-600 hover:text-blue-700 px-3 py-2 text-sm font-medium flex items-center gap-1"
                >
                  <Icon name="info" size="small" />
                  How It Works
                </Link>
                <Link
                  to="/architecture"
                  className="text-purple-600 hover:text-purple-700 px-3 py-2 text-sm font-medium flex items-center gap-1"
                >
                  <Icon name="architecture" size="small" />
                  Architecture
                </Link>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                <>
                  <span className="text-sm text-gray-600">Hello, {user?.displayName}</span>
                  <button onClick={handleLogout} className="btn-secondary text-sm">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="btn-secondary text-sm">
                    Login
                  </Link>
                  <Link to="/register" className="btn-primary text-sm">
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>

      <footer className="bg-white border-t">
        <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-gray-500">
            Actor-Based Auction Platform Demo - Built with Cloudflare Workers + Durable Objects
          </p>
        </div>
      </footer>
    </div>
  );
}
